import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { useApp } from "../context";

import { Category } from "../parse";
import { AdminList } from "./AdminList";

export const AdminCategoryRoute = observer(function AdminCategoryRoute() {
  const app = useApp();
  const { t } = useTranslation();

  return (
    <AdminList
      title={t("admin-categories")}
      className={Category.className}
      navName="category"
      rows={app.benchmarks.categories}
    />
  );
});
